export default __webpack_public_path__ + "static/customer-b90bf4d15f83fd89b2bbf3fbf21b7ad8.png";